import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state:{
    informPop: false,
    online_sum: 0,
    notice:[],
    system_notice:[],
    Customerlaborcost:{}
  },
  mutations: {
    Customerlaborcost(state, payload) {
      state.Customerlaborcost = payload;
    }
  }
});
 
export default store;